import { Card, Divider, FormInstance, Row, Tooltip } from "antd";
import { NextDueDateRow } from "./NextDueDateRow";
import { ClockCircleOutlined } from "@ant-design/icons";
import { FormData } from "./FormData";
import { useMemo } from "react";

type FirstStepProps = {
  data: any;
  form: FormInstance;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setRequest: React.Dispatch<React.SetStateAction<any>>;
};

export const FirstStep = ({
  data,
  form,
  setStep,
  setRequest,
}: FirstStepProps) => {
  const accountData: string = useMemo(
    () =>
      `#${data.contractNumber}${data.propertyAddress ? " - " + data.propertyAddress : ""}`,
    [data],
  );

  return (
    <Card className="step">
      <Tooltip
        placement="top"
        title={accountData}
        overlayClassName="text-sm"
        overlayStyle={{
          maxWidth: "363px",
        }}
      >
        <p className="mt-0 mb-2 text w-500 w-100 elipsis">{accountData}</p>
      </Tooltip>
      <Row>
        <NextDueDateRow nextDueDate={data.nextPaymentDate} />
        <Row className="w-100 align-start desc-container">
          <ClockCircleOutlined className="mr-2 text-md title" />
          <p className="my-0 text-md title desc">
            Payments made on weekends or holidays will be posted the next
            business day and effective-dated for that business day.
          </p>
        </Row>
      </Row>
      <Divider className="my-8" />
      <FormData
        amount={data.nextPaymentAmount}
        form={form}
        setStep={setStep}
        setRequest={setRequest}
      />
    </Card>
  );
};
